import { jsx as _jsx } from "react/jsx-runtime";
import { Popover } from '@blueprintjs/core';
import styled from '@emotion/styled';
import FixedColorPreview from '../preview/FixedColorPreview';
import { ColorPicker } from '../react-color/ColorPicker';
import * as colorHelper from '../react-color/helpers/color';
const ColorPickerRoot = styled.button `
  position: relative;
  width: 100%;
  border: 1px solid darkgray;
  border-radius: 0.25rem;
  height: 30px;
  padding: 5px;
`;
const ColorPickerPreview = styled.div `
  height: 100%;
  width: 100%;
  border-radius: 0.125rem;
`;
export function ColorPickerDropdown(props) {
    const { color, popoverProps, ...otherProps } = props;
    const { hex } = colorHelper.toState(color || 'white');
    return (_jsx(Popover, { targetProps: { style: { width: '100%' } }, content: _jsx(ColorPicker, { color: color, ...otherProps }), minimal: true, ...popoverProps, children: _jsx(ColorPickerRoot, { type: "button", children: _jsx(ColorPickerPreview, { children: _jsx(FixedColorPreview, { color: hex }) }) }) }));
}
//# sourceMappingURL=ColorPickerDropdown.js.map